import { render } from "./ProductReviewPage.vue?vue&type=template&id=5887e394&scoped=true"
import script from "./ProductReviewPage.vue?vue&type=script&lang=js"
export * from "./ProductReviewPage.vue?vue&type=script&lang=js"

import "./ProductReviewPage.vue?vue&type=style&index=0&id=5887e394&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5887e394"]])

export default __exports__